var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calender",
    transform: "translate(-1701 -7538)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1544",
    "data-name": "Ellipse 1544",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(1701 7538)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36053",
    "data-name": "Path 36053",
    d: "M31.78,6.5v3.3H1V6.5A3.307,3.307,0,0,1,4.3,3.2H7.6V1h2.2V3.2H22.986V1h2.2V3.2h3.3A3.307,3.307,0,0,1,31.78,6.5Zm2.2,19.787a7.7,7.7,0,1,1-7.7-7.7A7.7,7.7,0,0,1,33.979,26.284Zm-3.3-1.1h-3.3v-3.3h-2.2v3.3h-3.3v2.2h3.3v3.3h2.2v-3.3h3.3Zm1.1-13.191v6.068A9.889,9.889,0,0,0,18.061,31.78H4.3a3.308,3.308,0,0,1-3.3-3.3V11.993ZM10.894,24.085H6.5v2.2h4.4Zm0-6.6H6.5v2.2h4.4Z",
    transform: "translate(1716 7553)",
    fill: "#0180e5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.dbe8a7d243d3a0a572bda101333e9ee0.svg";
export { ForwardRef as ReactComponent };